module.exports = __webpack_public_path__ + "assets/img/9336-pe.svg";